<template>
  <div>
    <Input
      v-if="input.includes($attrs.type)"
      :type="$attrs.type|filterInputType"
      :clearable="clearable"
      v-bind="attrs"
      v-on="$listeners"
    >
    <Icon
      v-if="$attrs.prependIcon"
      slot="prepend"
      :type="$attrs.prependIcon"
    ></Icon>
    </Input>
    <MyPassword
      v-if="$attrs.type=='myPassword'"
      v-bind="attrs"
      :clearable="clearable"
      v-on="$listeners"
    ></MyPassword>
    <Input
      v-if="$attrs.type=='passwordEye'"
      :type="eye?'text':'password'"
      v-bind="attrs"
      v-on="$listeners"
    >
    <Icon
      v-if="eye == true"
      slot="suffix"
      type="md-eye-off"
      @click="eye=false"
    />
    <Icon
      v-else
      slot="suffix"
      type="md-eye"
      @click="eye=true"
    />
    </Input>
    <AutoComplete
      v-if="$attrs.type == 'autoComplete'"
      :value="$attrs.value"
      icon="ios-search"
      :clearable="clearable"
      :placeholder="$attrs.placeholder"
      class="my-autoComplete"
      v-on="$listeners"
    >
      <Option
        v-for="(sitem,sindex) in currentData"
        :key="sindex"
        :value="sitem.value"
      >
        {{ sitem.label }}
      </Option>
    </AutoComplete>
    <Select
      v-if="$attrs.type == 'select'"
      v-bind="attrs"
      :clearable="clearable"
      v-on="$listeners"
    >
      <Option
        v-for="(item,index) in currentData"
        :key="index"
        :value="item.value"
      >
        {{ item.label }}
      </Option>
    </Select>
    <RadioGroup
      v-if="$attrs.type == 'radioGroup'"
      :value="$attrs.value"
      v-on="$listeners"
    >
      <Radio
        v-for="(item,index) in currentData"
        :key="index"
        :label="item.value"
      >
        <i
          v-if="item.iconfont"
          :class="['iconfont',item.iconfont]"
        ></i>
        <span class="radio-label">{{ item.label }}</span>
      </Radio>
    </RadioGroup>
    <CheckboxGroup
      v-if="$attrs.type == 'checkboxGroup'"
      v-bind="attrs"
      v-on="$listeners"
    >
      <Checkbox
        v-for="(item,index) in currentData"
        :key="index"
        :label="item.value"
      >
        <span>{{ item.label }}</span>
      </Checkbox>
    </CheckboxGroup>
    <Switch
      v-if="$attrs.type == 'switch'"
      v-bind="attrs"
      v-on="$listeners"
    />
    <MyUpload
      v-if="upload.includes($attrs.type)"
      v-bind="attrs"
      v-on="$listeners"
    ></MyUpload>
    <MyCitySelect
      v-if="$attrs.type == 'citySelect'|| $attrs.type =='citySelectText'"
      v-bind="attrs"
      v-on="$listeners"
    ></MyCitySelect>
    <Cascader
      v-if="$attrs.type == 'cascader'"
      v-bind="attrs"
      v-on="$listeners"
    ></Cascader>

    <DatePicker
      v-if="['date', 'datetime','month','year'].includes($attrs.type)"
      v-bind="attrs"
      v-on="$listeners"
    >
    </DatePicker>
    <MySlider
      v-if="$attrs.type == 'slider'"
      v-bind="attrs"
      v-on="$listeners"
    ></MySlider>
    <!--        展示-->
    <span
      v-if="span.includes($attrs.type)"
      class="detail-text"
      :class="{'detail-textareaText':$attrs.value && $attrs.value.length>300}"
    >
      {{ $attrs.value }}
    </span>
    <span
      v-if="$attrs.type=='myPasswordText'"
      class="detail-text"
    >
      {{ $attrs.value|passFormat }}
    </span>
    <span
      v-if="selectSpan.includes($attrs.type)"
      class="detail-text"
    >
      {{ $attrs.value|selectFilter(currentData) }}
    </span>
    <div
      v-if="$attrs.type=='uploadText'"
      class="upload-img-box"
    >
      <!--如果是图片-->
      <template v-if="$attrs.value">
        <span
          v-for="(item,index) in $attrs.value.split(',')"
          :key="index"
          class="file-show-box"
        >
          <img
            v-if="/(.png)|(.jpg)|(.jpeg)|(.gif)$/i.test(item)"
            :src="item"
          >
          <span v-else>{{ $attrs.showUploadUrl?$attrs.value:'已上传' }}</span>
        </span>
      </template>
      <span
        v-else
        class="no-img"
      >未上传</span>
    </div>
    <render
      v-if="['render','renderText'].includes($attrs.type)"
      :render="$attrs.render"
      :params="$attrs"
    ></render>
  </div>
</template>
<script>
import MySlider from '@/components/Form/Slider';
import MyUpload from '@/components/Form/Upload';
import MyCitySelect from '@/components/Form/CitySelect';
import MyPassword from '@/components/Form/Password';
import render from '@/components/Base/Render';

export default {
  components: { MyUpload, MySlider, MyCitySelect, MyPassword, render },
  filters: {
    selectFilter(value, data) {
      let label = '';
      if (data instanceof Array) {
        if (value instanceof Array) {
          const labelArr = [];
          data.forEach((ele) => {
            if (value.includes(ele.value)) {
              labelArr.push(ele.label);
            }
          });
          label = labelArr.join('、').replace(/、$/, '');
        } else {
          const item = data.find((ele) => ele.value === value) || {};
          label = item.label;
        }
      }
      return label;
    },
    filterInputType(value) {
      if (value == 'input') {
        value = 'text';
      }
      return value;
    },
  },
  inheritAttrs: false,
  props: {
    // placeholder: {
    //   type: String,
    //   default: '',
    // },
    // disabled: {
    //     type: Boolean,
    //     default:false
    // },
    data: {
      type: [Function, Array],
      default: null,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      input: ['text', 'password', 'textarea', 'url', 'email', 'number', 'tel', 'input'],
      span: ['textText', 'inputText', 'autoCompleteText', 'datetimeText', 'dateText', 'textareaText', 'areaText'],
      selectSpan: ['selectText', 'radioText', 'checkboxText', 'checkboxGroupText'],
      upload: ['uploadFile', 'upload'],
      eye: this.$attrs.eye || false,

      currentData: [],
    };
  },
  computed: {
    attrs() {
      const attrs = { ...this.$attrs };
      delete attrs.on;
      delete attrs.rules;
      delete attrs.label;
      return attrs;
    },
  },
  watch: {
    data: {
      handler() {
        if (this.data && typeof this.data === 'function') {
          const fun = this.data();
          if (fun.then) {
            fun.then((res) => {
              this.currentData = res;
            });
          } else {
            this.currentData = fun;
          }
        } else {
          this.currentData = this.data;
        }
      },
      immediate: true,
    },
  },
  created() {
  },
};
</script>

<style scoped lang="less">
    .detail-text {
      /* box-sizing: border-box; */
      /* display: inline-block; */
      /* width: 100%; */
      /* background-color: #cccccc14; */
      /* border: 1px solid #e5e5e5; */
      /* border-radius: 5px; */
      /* padding: 0 10px; */
      /* min-height: 33px; */
    }
    .detail-textareaText {
      word-break: break-all;
      overflow-y: auto;
      max-height: 99px;
      line-height: 1.7;
      padding: 7px;
    }
    .upload-img-box img {
      width: 70px;
      height: 70px;
    }

    .no-img {
      display: inline-block;
      width: 70px;
      height: 70px;
      border: 1px dashed #e5e5e5;
      text-align: center;
      line-height: 70px;
      color: #999;
    }

    .my-autoComplete {
      /deep/ .ivu-select-dropdown-list {
        max-height: 280px;
        max-width: 180px;
        overflow: auto;
      }

    }
    .file-show-box {
      display: inline-block;
      margin-right: 10px;
      vertical-align: middle;
    }
    .radio-label {
      display: inline-block;
      vertical-align: middle;
    }
</style>
